// extracted by mini-css-extract-plugin
module.exports = {"uploadWrap":"Upload_uploadWrap__2-JLz","uploadInput":"Upload_uploadInput__wTdCa"};